<script setup lang="ts">
export interface ProseAProps {
    href?: string
}

defineProps<ProseAProps>()
</script>

<template>
    <NuxtLink v-if="href" :to="href">
        <slot />
    </NuxtLink>
    <slot v-else />
</template>
